import { makeStyles } from "@mui/styles";

export const useZoomPlayerStyles = makeStyles({
  container: {
    display: "flex",
    height: "100%",
    borderRadius: 8,
    position: "relative",
    flexDirection: "row",
    minHeight: "400px",
    "@media (max-width:1024px)": {
      flexDirection: "column",
      minHeight: "500px",
    },
    "@media (max-width:600px)": {
      minHeight: "450px",
    },
  },
  leftPane: {
    display: "flex",
    flexDirection: "column",
    flexBasis: "70%",
    minHeight: "300px",
    "@media (max-width:900px)": {
      flexBasis: "50%",
      minHeight: "250px",
    },
    "@media (max-width:600px)": {
      flexBasis: "55%",
      minHeight: "200px",
    },
  },
  playerHeader: {
    backgroundColor: "#fff",
    color: "#111",
    "@media (max-width:900px)": {
      display: "none",
    },
  },
  playerTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    "@media (max-width:600px)": {
      fontSize: "1.2rem",
      padding: "8px 12px",
    },
  },
  videoContainer: {
    position: "relative",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 480,
    flex: 1,
    width: "100%",
    "@media (max-width:900px)": {
      minHeight: 250,
    },
    "@media (max-width:600px)": {
      minHeight: 200,
    },
  },
  videoEl: {
    width: "100%",
    height: "100%",
    objectFit: "contain" as const,
    outline: "none",
    border: 0,
    borderRadius: 16,
  },
  loadingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000",
    zIndex: 2,
  },
  progressBar: { width: 200 },
  errorOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.8)",
    zIndex: 3,
    gap: 8,
    paddingInline: 16,
    textAlign: "center" as const,
  },
  retryChip: {
    color: "#fff !important",
    borderColor: "rgba(255,255,255,0.7) !important",
    borderWidth: "1px !important",
    borderStyle: "solid !important",
  },
  bufferingOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 3,
  },
  transcriptPanel: {
    flexBasis: "30%",
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "90vh",
    minHeight: "300px",
    overflow: "hidden",
    "@media (max-width:900px)": {
      borderLeft: "none",
      borderTop: "1px solid #e0e0e0",
      flexBasis: "auto",
      height: "auto",
      maxHeight: "350px",
      minHeight: "250px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
    "@media (max-width:600px)": {
      flexBasis: "auto",
      maxHeight: "300px",
      minHeight: "200px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
  },
  transcriptHeader: {
    padding: 10,
    flexShrink: 0,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    "@media (max-width:600px)": {
      padding: 12,
    },
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: "#ffffff",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#d1d5db",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#94a3b8",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1976d2",
      borderWidth: 2,
    },
  },
  transcriptScroll: {
    flex: 1,
    overflowY: "auto" as const,
    overflowX: "hidden" as const,
    minHeight: 600,
    isolation: "isolate",
    position: "relative",
    "@media (max-width:900px)": {
      maxHeight: "inherit",
      padding: 6,
      minHeight: 180,
    },
    "@media (max-width:600px)": {
      padding: 4,
      minHeight: 160,
    },
  },
  transcriptItem: {
    padding: 12,
    marginBottom: 4,
    borderRadius: 4,
    cursor: "pointer",
    transition: "none",
    "&:hover": {
      backgroundColor: "#f3f6f9",
    },
    "@media (max-width:600px)": {
      padding: 8,
      marginBottom: 2,
    },
  },
  transcriptItemActive: {
    backgroundColor: "#e3f2fd",
    borderLeft: "3px solid #1976d2",
  },
  transcriptItemSeeking: {
    backgroundColor: "#fff3e0",
    borderLeft: "3px solid #ff9800",
    opacity: 0.8,
  },
  rowCenterGap8Mb4: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 4,
  },
  speakerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  timeCaption: {
    color: "#7a7a7a",
    fontSize: "0.8rem",
  },
  transcriptText: {
    color: "#333",
    fontWeight: 400,
    lineHeight: 1.4,
    "@media (max-width:600px)": {
      fontSize: "0.85rem",
      lineHeight: 1.3,
    },
  },
  transcriptTextActive: {
    color: "#1976d2",
    fontWeight: 600,
    lineHeight: 1.4,
    "@media (max-width:600px)": {
      fontSize: "0.85rem",
      lineHeight: 1.3,
    },
  },
  overlayWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    bottom: 60,
    zIndex: 5,
    pointerEvents: "none" as const,
    padding: "0 16px",
    "@media (max-width:900px)": {
      bottom: 50,
      padding: "0 12px",
    },
    "@media (max-width:600px)": {
      bottom: 40,
      padding: "0 8px",
    },
  },
  overlayBox: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#fff",
    padding: "12px 16px",
    borderRadius: 8,
    backdropFilter: "blur(10px)",
    maxWidth: "80%",
    width: "max-content",
    textAlign: "center" as const,
    maxHeight: 120,
    overflow: "hidden",
    pointerEvents: "auto" as const,
    "@media (max-width:900px)": {
      maxWidth: "92%",
      padding: "8px 12px",
      maxHeight: 100,
    },
    "@media (max-width:600px)": {
      maxWidth: "95%",
      padding: "6px 10px",
      maxHeight: 80,
      fontSize: "0.85rem",
    },
  },
  captionRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
    justifyContent: "center",
  },
  captionChip: {
    backgroundColor: "rgba(25,118,210,0.8)",
    color: "#fff",
    padding: "2px 8px",
    borderRadius: 12,
    fontSize: "0.7rem",
    fontWeight: 600,
  },
  captionTime: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "0.7rem",
  },
  captionText: {
    color: "#fff",
    lineHeight: 1.4,
    fontSize: "0.9rem",
    fontWeight: 500,
    textAlign: "center" as const,
    "@media (max-width:600px)": {
      fontSize: "0.8rem",
      lineHeight: 1.3,
    },
  },
  textWhite: { color: "#fff" },
  textMuted: { color: "#bbb" },

  summaryWrapper: {
    backgroundColor: "#fff",
    color: "#111",
    padding: 16,
    flexShrink: 0,
    overflow: "scroll",
    "@media (max-width:900px)": {
      padding: 12,
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
    "@media (max-width:600px)": {
      padding: 8,
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
    },
  },
  summaryTitle: {
    fontWeight: 700,
    marginBottom: 8,
    "@media (max-width:600px)": {
      fontSize: "1.1rem",
      marginBottom: 6,
    },
  },
  summarySectionTitle: {
    fontWeight: 600,
    fontSize: "0.95rem",
    marginTop: 8,
    marginBottom: 4,
    "@media (max-width:600px)": {
      fontSize: "0.9rem",
      marginTop: 6,
      marginBottom: 3,
    },
  },
  summaryList: {
    margin: 0,
    paddingLeft: 18,
    "@media (max-width:600px)": {
      paddingLeft: 14,
    },
  },
  summaryItem: {
    fontSize: 13,
    "@media (max-width:600px)": {
      fontSize: 12,
      lineHeight: 1.4,
    },
  },
  resumeBar: {
    display: "flex",
    justifyContent: "center",
    padding: 8,
    borderTop: "1px solid #e0e0e0",
    backgroundColor: "#fff",
  },
  resumeBtn: {
    textTransform: "none" as const,
    backgroundColor: "#1976d2 !important",
    color: "#fff !important",
    fontWeight: 600,
    borderRadius: 999,
    paddingInline: 14,
    paddingBlock: 6,
  },
});
